import { render, staticRenderFns } from "./ChannelVipConfig.vue?vue&type=template&id=3f8370e2&"
import script from "./ChannelVipConfig.vue?vue&type=script&lang=js&"
export * from "./ChannelVipConfig.vue?vue&type=script&lang=js&"
import style0 from "./ChannelVipConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports